export const GRANULAR_STATUS = {
  PENDING_PICKUP: 'PENDING_PICKUP',
  PENDING_PICKUP_AT_DISTRIBUTION_POINT: 'PENDING_PICKUP_AT_DISTRIBUTION_POINT',
  VAN_EN_ROUTE_TO_PICKUP: 'VAN_EN_ROUTE_TO_PICKUP',
  EN_ROUTE_TO_SORTING_HUB: 'EN_ROUTE_TO_SORTING_HUB',
  PICKUP_FAIL: 'PICKUP_FAIL',
  ARRIVED_AT_SORTING_HUB: 'ARRIVED_AT_SORTING_HUB',
  ON_VEHICLE_FOR_DELIVERY: 'ON_VEHICLE_FOR_DELIVERY',
  COMPLETED: 'COMPLETED',
  PENDING_RESCHEDULE: 'PENDING_RESCHEDULE',
  TRANSFERRED_TO_3PL: 'TRANSFERRED_TO_3PL',
  RETURNED_TO_SENDER: 'RETURNED_TO_SENDER',
  CANCELLED: 'CANCELLED',
  ARRIVED_AT_DISTRIBUTION_POINT: 'ARRIVED_AT_DISTRIBUTION_POINT',
  ARRIVED_AT_ORIGIN_HUB: 'ARRIVED_AT_ORIGIN_HUB',
  CROSS_BORDER_IN_TRANSIT: 'CROSS_BORDER_IN_TRANSIT',
  CROSS_BORDER_CUSTOMS_CLEARED: 'CROSS_BORDER_CUSTOMS_CLEARED',
  CROSS_BORDER_CUSTOMS_HELD: 'CROSS_BORDER_CUSTOMS_HELD',
  STAGING: 'STAGING',
  ON_HOLD: 'ON_HOLD'
}

export const GRANULAR_STATUS_TEXT = {
  PENDING_PICKUP: 'Pending Pickup',
  PENDING_PICKUP_AT_DISTRIBUTION_POINT: 'Pending Pickup at Distribution Point',
  VAN_EN_ROUTE_TO_PICKUP: 'Van en-route to Pickup',
  EN_ROUTE_TO_SORTING_HUB: 'En-route to Sorting Hub',
  PICKUP_FAIL: 'Pickup Fail',
  ARRIVED_AT_SORTING_HUB: 'Arrived at Sorting Hub',
  ON_VEHICLE_FOR_DELIVERY: 'On Vehicle for Delivery',
  COMPLETED: 'Completed',
  PENDING_RESCHEDULE: 'Pending Reschedule',
  TRANSFERRED_TO_3PL: 'Transferred to 3PL',
  RETURNED_TO_SENDER: 'Returned to Sender',
  CANCELLED: 'Cancelled',
  ARRIVED_AT_DISTRIBUTION_POINT: 'Arrived at Distribution Point',
  ARRIVED_AT_ORIGIN_HUB: 'Arrived at Origin Hub',
  CROSS_BORDER_IN_TRANSIT: 'Cross Border Transit',
  CROSS_BORDER_CUSTOMS_CLEARED: 'Customs Cleared',
  CROSS_BORDER_CUSTOMS_HELD: 'Customs Held',
  STAGING: 'Staging',
  ON_HOLD: 'On Hold'
}

export const JOB_TYPE = {
  PARCEL_PICKUP: 'parcel-pickup',
  PARCEL_PICKUP_APPOINTMENT: 'parcel-pickup-appointment',
  PARCEL_DELIVERY: 'parcel-delivery',
  PARCEL_TRANSIT: 'parcel-transit',
  PARCEL_TRANSFER_TO_PUDO: 'parcel-transfer-to-pudo',
  PARCEL_RETRIEVAL_FROM_PUDO: 'parcel-retrieval-from-pudo',
  PUDO_PARCEL_RELEASE: 'pudo-parcel-release',
  PUDO_PARCEL_RECEIVE: 'pudo-parcel-receive'
}

export const PARCEL_SIZE = ['S', 'M', 'L', 'XL', 'XXL']
